import React from 'react';

import { Link } from 'react-router-dom';

// images
import logo from '../../assets/images/logo.png';
import background_image_1 from '../../assets/images/patterns/pattern-1.jpg';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 offset-lg-0 col-md-8 offset-md-2 col-10 offset-1">
                            <div className="footer-row">
                                <div className="footer-detail">
                                    <Link to="#">
                                        <img src={logo} alt="footer-logo" />
                                    </Link>
                                    <p className="c-grey-1">Rooted in the heart of Peru, trusted around the world. We bring you organic superfoods cultivated with care, tradition, and respect for nature.</p>
                                    <div className="links">
                                        <a className="link-underline" href="mailto:hello@orions.com">
                                            <span>contacto@amazon-andes.com</span>
                                        </a>
                                       </div>
                                </div>
                                <div className="footer-list footer-social social-gradient">
                                    <h6>Follow</h6>
                                    <ul>
                                        <li className="instagram">
                                            <Link to="https://www.instagram.com/amazonandes.export" className="link-underline">
                                                <i className="fab fa-instagram"></i>
                                                <span>Instagram</span>
                                            </Link>
                                        </li>
                                        <li className="facebook">
                                            <Link to="https://www.facebook.com/amazonandesexport" className="link-underline">
                                                <i className="fab fa-facebook"></i>
                                                <span>Facebook</span>
                                            </Link>
                                        </li>
                                        <li className="linkedin">
                                            <Link to="https://www.linkedin.com/company/amazon-andes-export" className="link-underline">
                                                <i className="fab fa-linkedin-in"></i>
                                                <span>Linkedin</span>
                                            </Link>
                                        </li>
                                        <li className="youtube">
                                            <Link to="https://www.youtube.com/channel/UCeAVeG108MWB5QQslfsMn8w" className="link-underline">
                                                <i className="fab fa-youtube"></i>
                                                <span>Youtube</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 offset-lg-0 col-md-8 offset-md-2 col-10 offset-1">
                            <div className="footer-copyright c-grey-1">
                                <h6>&copy; Anazon Andes</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-pattern" style={{backgroundImage: `url(${background_image_1})`}}></div>
            </div>
        </footer>
    );
};

export default Footer;
